declare namespace $ {

	export class $bog_builderui_tabs extends $mol_switch {
	}
	
}

//# sourceMappingURL=tabs.view.tree.d.ts.map